export default __webpack_public_path__ + "static/media/dt3.a506ac75.jpg";